const I18n = globalThis.I18n;

export default I18n;
